/* tslint:disable:no-inferrable-types no-trailing-whitespace import-spacing typedef-whitespace align whitespace quotemark */

import {
  ComponentFactoryResolver,
  EmbeddedViewRef,
  ViewContainerRef
} from "@angular/core";

import { DocumentWindow }            from './document.window';
import { DocumentWindowManager }     from './document.window.manager';
import { Logger }                    from '@/util/logger';

import { BlobService }               from '@/services/blob.service';
import { AuthenticationService}      from '@/services/authentication.service';
import { IdeService}                 from '@/services/ide.service';
import { KPITableViewerMetadata }    from './k.p.i.table.viewer.metadata';

import { KPITableViewerComponent }   from '@/components/k.p.i.table.viewer.component';

import * as $                        from 'jquery';
import 'gasparesganga-jquery-loading-overlay'; /* https://gasparesganga.com/labs/jquery-loading-overlay/ */

import {ResizeObserver} from "resize-observer";

import {first} from "rxjs/operators";

/**
 *
 * @class KPITableViewerWindow
 *
 * @brief window for viewing all an aggregate KPI snapshot for an simulation
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class KPITableViewerWindow extends DocumentWindow {

  /** access to the virtual file system */
  private blobber:           BlobService = null;

  /** access to user authentication */
  private auth:    AuthenticationService = null;

  /** access to user authentication */
  private ide:                IdeService = null;

  /** the document manager we are a tab  of */
  private manager: DocumentWindowManager = null;

  /** the current job in focus */
  private focus:                 string = '';

  /** the actual editor */
  private viewer:   KPITableViewerComponent = null;

  /** standard constructor */
  constructor(
    meta: KPITableViewerMetadata,
    manager: DocumentWindowManager
  ) {

    super(manager, meta, manager.layoutManager());

    Logger.debug('[KPITableViewerWindow] constructing...');

    this.manager     = manager;
    this.auth        = this.manager.authService();
    this.blobber     = this.manager.blobService();
    this.ide         = this.manager.ideService();
    this.focus       = meta.focus;

    this.showViewer();
  }

  /** restore the search view (on current 'focus') */
  public showViewer() {

    Logger.debug(`[KPITableViewerWindow] => ${this.focus} ...`);

    const container: JQuery<HTMLElement> = $(`#${this.meta.id}`);

    if (!$(container) || !$(container).is('div')) {

      this.unReady();

      Logger.error(`[KPITableViewerWindow] missing hosting container (${this.meta.id})!`);

      return ;
    }

    $(container).html(`
<div id="kpt_viewer_${this.meta.id}" class="" style="height: 100%; width: 100%; display: block;">
</div>
`);

    const checkExist = setInterval(() => {

      const dom: HTMLElement = document.getElementById(`kpt_viewer_${this.meta.id}`) as HTMLElement;

      if (dom) {

        clearInterval(checkExist);

       // $(dom).css('height', '100%');

        Logger.debug(`[KPITableViewerWindow] init ...`);

        const    view: ViewContainerRef         = this.ide.view;
        const factory: ComponentFactoryResolver = this.ide.componentResolver;


        const creator      = factory.resolveComponentFactory(KPITableViewerComponent);
        const componentRef = view.createComponent(creator);

        this.viewer        = componentRef.instance  as KPITableViewerComponent;

        const domElem      = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;

        /* ensure the new component is parented under our container */

        dom.appendChild(domElem);

        /*
         * add a self watch for changes in wrapper size...because sometime it will change because
         * the panels around it have changed in size...not because the browser has changed in size;
         * that is, its not a window resize event, so that kind of size change wouldn't normally
         * be caught.
         *
         */
        const resizeObserver = new ResizeObserver(entries => {

          this.viewer.resize();
        });

        resizeObserver.observe( dom );

        /*  can now use 'viewer' as usual ... */

        /* load up the data! */

        setTimeout(() => {

          this.viewer.load(this.focus);

          },

          100
        );
      }

    }, 100);
  }

  /** update the focus to current */
  private updateFocus(focus: string) {

    this.focus  = focus;

    let keyBase = focus.substring(focus.lastIndexOf('/') + 1);

    if(!keyBase || keyBase === '' ) {

      keyBase = focus;
    }

    this.title  = `${keyBase}`;

  }

}
